<!-- Vehicle Upload Documents Modal -->
<div class="modal fade" id="kt_modal_vehicle_upload_documents" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-xl">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header d-flex justify-content-between align-items-center">
        <h2 class="fw-bold mb-0">Upload Vehicle Documents</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <!-- Modal Body -->
      <div class="modal-body scroll-y mx-5 mx-xl-15 my-7">
        <!-- Vehicle Info -->
        <div class="card mb-5" *ngIf="selectedVehicle">
          <div class="card-body p-4">
            <div class="d-flex align-items-center">
              <div class="symbol symbol-50px me-3">
                <div class="symbol-label rounded"
                     [style.background-image]="selectedVehicle.pictures && selectedVehicle.pictures.length > 0 ? 'url(' + selectedVehicle.pictures[0] + ')' : ''"
                     [class.bg-light-primary]="!selectedVehicle.pictures || selectedVehicle.pictures.length === 0"
                     style="background-size: cover; background-position: center;">
                  <i class="ki-duotone ki-car fs-2 text-primary" *ngIf="!selectedVehicle.pictures || selectedVehicle.pictures.length === 0">
                    <span class="path1"></span>
                    <span class="path2"></span>
                    <span class="path3"></span>
                  </i>
                </div>
              </div>
              <div>
                <h4 class="fw-bold mb-1">{{ selectedVehicle.make }} {{ selectedVehicle.model }} {{ selectedVehicle.year }}</h4>
                <p class="text-muted mb-0">Stock No: {{ selectedVehicle.stock_no || selectedVehicle.inventory_no || '-' }} | Chassis: {{ selectedVehicle.chassis_no || '-' }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Upload Form -->
        <div class="card mb-5">
          <div class="card-header">
            <h3 class="card-title">Upload New Documents</h3>
          </div>
          <div class="card-body">
            <form [formGroup]="documentForm" (ngSubmit)="onSubmit()" novalidate>
              <div class="row g-4">
                <!-- Document Type Dropdown -->
                <div class="col-md-6">
                  <label class="form-label required">Document Type</label>
                  <select class="form-select" formControlName="documentType">
                    <option value="">Select Document Type</option>
                    <option *ngFor="let docType of documentTypes" [value]="docType.value">{{ docType.label }}</option>
                  </select>
                  <div class="invalid-feedback" *ngIf="documentForm.get('documentType')?.invalid && documentForm.get('documentType')?.touched">
                    Please select a document type
                  </div>
                </div>

                <!-- File Upload -->
                <div class="col-md-6">
                  <label class="form-label required">Select Files</label>
                  <input type="file"
                         #fileInput
                         class="form-control"
                         multiple
                         accept="image/*,.pdf,.doc,.docx"
                         (change)="onFilesSelected($event)">
                  <div class="form-text">You can select multiple files (images, PDF, DOC, DOCX)</div>
                  <div class="invalid-feedback" *ngIf="selectedFiles.length === 0 && formSubmitted">
                    Please select at least one file
                  </div>
                </div>
              </div>

              <!-- Selected Files Preview -->
              <div class="row mt-4" *ngIf="selectedFiles.length > 0">
                <div class="col-12">
                  <h6 class="fw-bold mb-3">Selected Files ({{ selectedFiles.length }})</h6>
                  <div class="d-flex flex-wrap gap-3">
                    <div *ngFor="let file of selectedFiles; let i = index" class="border rounded p-2 d-flex align-items-center">
                      <i class="ki-duotone ki-file fs-2 text-primary me-2">
                        <span class="path1"></span>
                        <span class="path2"></span>
                      </i>
                      <div class="me-2">
                        <div class="fw-semibold">{{ file.name }}</div>
                        <div class="text-muted fs-7">{{ formatFileSize(file.size) }}</div>
                      </div>
                      <button type="button" class="btn btn-sm btn-icon btn-light-danger" (click)="removeFile(i)">
                        <i class="ki-duotone ki-cross fs-4">
                          <span class="path1"></span>
                          <span class="path2"></span>
                        </i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Upload Progress -->
              <div class="row mt-4" *ngIf="isUploading">
                <div class="col-12">
                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <span class="text-muted">Uploading documents...</span>
                    <span class="badge badge-light-primary">{{ uploadProgress.current }} / {{ uploadProgress.total }}</span>
                  </div>
                  <div class="progress">
                    <div class="progress-bar"
                         role="progressbar"
                         [style.width.%]="(uploadProgress.current / uploadProgress.total) * 100"
                         [attr.aria-valuenow]="uploadProgress.current"
                         [attr.aria-valuemax]="uploadProgress.total">
                    </div>
                  </div>
                </div>
              </div>

              <!-- Form Actions -->
              <div class="d-flex justify-content-end mt-6">
                <button type="button" class="btn btn-light me-3" data-bs-dismiss="modal" [disabled]="isUploading">
                  Cancel
                </button>
                <button type="submit"
                        class="btn btn-primary indicator"
                        style="min-width: 150px; height: 44px;"
                        [disabled]="isUploading || selectedFiles.length === 0">
                  <span class="indicator-label" *ngIf="!isUploading">Upload Documents</span>
                  <span class="indicator-progress" *ngIf="isUploading">
                    Please wait...
                    <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                  </span>
                </button>
              </div>
            </form>
          </div>
        </div>

        <!-- Existing Documents List -->
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">Existing Documents</h3>
          </div>
          <div class="card-body">
            <!-- No Documents State -->
            <div *ngIf="!selectedVehicle?.docs || getDocumentTypesCount() === 0" class="text-center py-5">
              <i class="ki-duotone ki-file-deleted fs-3x text-muted mb-3">
                <span class="path1"></span>
                <span class="path2"></span>
              </i>
              <p class="text-muted">No documents uploaded yet</p>
            </div>

            <!-- Documents List -->
            <div *ngIf="selectedVehicle?.docs && getDocumentTypesCount() > 0">
              <!-- Document Type Groups -->
              <div *ngFor="let docGroup of getDocumentTypes()" class="mb-5">
                <div class="d-flex align-items-center mb-3">
                  <h5 class="fw-bold mb-0 me-3">{{ getDocumentTypeLabel(docGroup.type) }}</h5>
                  <span class="badge badge-light-primary">{{ docGroup.urls.length }} file(s)</span>
                </div>

                <!-- Files in this document type -->
                <div class="row g-4">
                  <div *ngFor="let url of docGroup.urls; let urlIndex = index" class="col-md-6 col-lg-4">
                    <div class="card border border-gray-300">
                      <div class="card-body p-4">
                        <!-- Document Preview -->
                        <div class="text-center mb-3">
                          <!-- Image Preview -->
                          <div *ngIf="isImageFile(url)" class="symbol symbol-100px mx-auto">
                            <div class="symbol-label rounded"
                                 [style.background-image]="'url(' + url + ')'"
                                 style="background-size: cover; background-position: center;">
                            </div>
                          </div>
                          <!-- File Preview -->
                          <div *ngIf="!isImageFile(url)" class="symbol symbol-100px mx-auto bg-light-primary">
                            <div class="symbol-label rounded d-flex justify-content-center align-items-center">
                              <i class="ki-duotone ki-file fs-2x text-primary">
                                <span class="path1"></span>
                                <span class="path2"></span>
                              </i>
                            </div>
                          </div>
                        </div>

                        <!-- Document Info -->
                        <div class="text-center">
                          <h6 class="fw-bold mb-1">{{ getDocumentTypeLabel(docGroup.type) }}</h6>
                          <p class="text-muted fs-7 mb-3">{{ getFileExtension(url) | uppercase }} File</p>

                          <!-- Actions -->
                          <div class="d-flex justify-content-center gap-2">
                            <button type="button" class="btn btn-sm btn-light-primary" (click)="previewDocument(url)">
                              <i class="ki-duotone ki-eye fs-4">
                                <span class="path1"></span>
                                <span class="path2"></span>
                                <span class="path3"></span>
                              </i>
                              Preview
                            </button>
                            <button type="button" class="btn btn-sm btn-light-danger" (click)="deleteDocument(docGroup.type, urlIndex)">
                              <i class="ki-duotone ki-trash fs-4">
                                <span class="path1"></span>
                                <span class="path2"></span>
                                <span class="path3"></span>
                                <span class="path4"></span>
                                <span class="path5"></span>
                              </i>
                              Delete
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
